/**
 * 이니시스 가상계좌 환불 은행코드 목록.
 * 백엔드 `inicis.BankCodeMap`(backend/package_go/lib/pg/inicis/type.go) 및
 * web `core/utils/lib/constants.ts`의 BANK_CODES와 동일 셋. 백엔드가 코드 유효성을 검증하므로 동일해야 한다.
 * select value=code, label=name.
 * @type {{code: string, name: string}[]}
 */
export const BANK_CODES = [
  {code: '02', name: '한국산업은행'},
  {code: '03', name: '기업은행'},
  {code: '04', name: '국민은행'},
  {code: '05', name: '하나은행(구외환)'},
  {code: '06', name: '국민은행(구주택)'},
  {code: '07', name: '수협중앙회'},
  {code: '11', name: '농협중앙회'},
  {code: '12', name: '단위농협'},
  {code: '16', name: '축협중앙회'},
  {code: '20', name: '우리은행'},
  {code: '21', name: '구)조흥은행'},
  {code: '22', name: '상업은행'},
  {code: '23', name: 'SC제일은행'},
  {code: '24', name: '한일은행'},
  {code: '25', name: '서울은행'},
  {code: '26', name: '구)신한은행'},
  {code: '27', name: '한국씨티은행(구한미)'},
  {code: '31', name: '대구은행'},
  {code: '32', name: '부산은행'},
  {code: '34', name: '광주은행'},
  {code: '35', name: '제주은행'},
  {code: '37', name: '전북은행'},
  {code: '38', name: '강원은행'},
  {code: '39', name: '경남은행'},
  {code: '45', name: '새마을금고'},
  {code: '48', name: '신용협동조합중앙회'},
  {code: '50', name: '상호저축은행'},
  {code: '53', name: '한국씨티은행'},
  {code: '54', name: '홍콩상하이은행'},
  {code: '55', name: '도이치은행'},
  {code: '56', name: 'ABN암로'},
  {code: '57', name: 'JP모건'},
  {code: '59', name: '미쓰비시도쿄은행'},
  {code: '60', name: 'BOA'},
  {code: '64', name: '산림조합'},
  {code: '70', name: '신안상호저축은행'},
  {code: '71', name: '우체국'},
  {code: '81', name: '하나은행'},
  {code: '83', name: '평화은행'},
  {code: '87', name: '신세계'},
  {code: '88', name: '신한(통합)은행'},
  {code: '89', name: '케이뱅크'},
  {code: '90', name: '카카오뱅크'},
  {code: '91', name: '네이버포인트'},
  {code: '92', name: '토스뱅크'},
  {code: '93', name: '토스머니'},
  {code: '94', name: 'SSG머니'},
  {code: '96', name: '엘포인트'},
  {code: '97', name: '카카오머니'},
  {code: '98', name: '페이코포인트'},
  {code: 'D1', name: '유안타증권'},
  {code: 'D2', name: '현대증권'},
  {code: 'D3', name: '미래에셋증권'},
  {code: 'D4', name: '한국투자증권'},
  {code: 'D5', name: '우리투자증권'},
  {code: 'D6', name: '하이투자증권'},
  {code: 'D7', name: 'HMC투자증권'},
  {code: 'D8', name: 'SK증권'},
  {code: 'D9', name: '대신증권'},
  {code: 'DA', name: '하나대투증권'},
  {code: 'DB', name: '굿모닝신한증권'},
  {code: 'DC', name: '동부증권'},
  {code: 'DD', name: '유진투자증권'},
  {code: 'DE', name: '메리츠증권'},
  {code: 'DF', name: '신영증권'},
  {code: 'DG', name: '대우증권'},
  {code: 'DH', name: '삼성증권'},
  {code: 'DI', name: '교보증권'},
  {code: 'DJ', name: '키움증권'},
  {code: 'DK', name: '이트레이드'},
  {code: 'DL', name: '솔로몬증권'},
  {code: 'DM', name: '한화증권'},
  {code: 'DN', name: 'NH증권'},
  {code: 'DO', name: '부국증권'},
  {code: 'DP', name: 'LIG증권'},
  {code: 'BW', name: '뱅크월렛'},
  {code: 'DQ', name: '디올투자증권'},
  {code: 'DR', name: '토스증권'},
];
